import { CommonConstant } from "shared/constants/common-constant"
import { useStores } from "stores/root-store"
import { WarningMessage, WarningMessageWrapper } from "components/common/styles"
import { Box, Card, CardContent, CardHeader } from "@mui/material"
import NoRecordImage from "assets/estore-NoRecord.png"
import { CommonHyperlink, CustomDataGrid } from "components/common-styles"
import { useNavigate } from "react-router-dom"

const BomComponents = () => {
  const navigate = useNavigate()
  const { BillOfMaterialStore } = useStores()
  const bomInfo = { ...BillOfMaterialStore.bomInfo }

  const columns = [
    {
      field: "build_sequence",
      headerName: "Build Sequence",
      width: 200,
    },
    {
      field: "item",
      headerName: "Product",
      flex: 1,
      renderCell: params => <CommonHyperlink>{params.value}</CommonHyperlink>,
    },
    {
      field: "qty_needed_per_item",
      headerName: "Qty Per Item",
      flex: 1,
    },
  ]

  const handleCellClicked = params => {
    if (params.field === "item") {
      navigate(`/products/${encodeURIComponent(params.row["item"])}`)
    }
  }

  return (
    <Card id="cardComponents">
      <CardHeader title="Components" />
      <CardContent>
        {bomInfo.details?.length == 0 ? (
          <WarningMessageWrapper style={{ backgroundColor: "white" }}>
            <Box component="img" sx={{ maxWidth: 200 }} src={NoRecordImage} />
            <WarningMessage>{"The requested product could not be located in the system. Please contact ops@estorelogistics.com.au if you believe this error is incorrect."}</WarningMessage>
          </WarningMessageWrapper>
        ) : (
          <CustomDataGrid
            getRowId={row => row.build_sequence}
            rows={bomInfo.details}
            columns={columns}
            initialState={{
              sorting: {
                sortModel: [{ field: "build_sequence", sort: CommonConstant.ASCENDING }],
              },
              pagination: {
                paginationModel: {
                  pageSize: 15,
                },
              },
            }}
            pageSizeOptions={[10, 15, 20, 50]}
            onCellClick={handleCellClicked}
          />
        )}
      </CardContent>
    </Card>
  )
}

export default BomComponents
